namespace GeniuzPOS.Purchase {
    export namespace PoCreditNoteDtService {
        export const baseUrl = 'Purchase/PoCreditNoteDt';

        export declare function Create(request: Serenity.SaveRequest<PoCreditNoteDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoCreditNoteDtRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoCreditNoteDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoCreditNoteDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoCreditNoteDt/Create",
            Update = "Purchase/PoCreditNoteDt/Update",
            Delete = "Purchase/PoCreditNoteDt/Delete",
            Retrieve = "Purchase/PoCreditNoteDt/Retrieve",
            List = "Purchase/PoCreditNoteDt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoCreditNoteDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
